import html from 'html-react-parser'

import { StepItem, Question, Index, Answer } from './Step.styled'

interface Step {
  question: string
  answer: string
}
interface Props {
  index: number
  step: Step
}

function Step(props: Props) {
  const { step, index } = props

  return (
    <StepItem>
      <Question strong={true}>
        <Index>{index}</Index>
        {step.question && html(step.question)}
      </Question>
      {step.answer && <Answer>{html(step.answer)}</Answer>}
    </StepItem>
  )
}

export default Step
